import { devtools } from "zustand/middleware";
import { DEVTOOLS_ENABLED } from "../../consts";
import { create } from "../../feat/appState/resetState";

/** Height of the itinerary carousel header. It keeps that height, sliding off the top of
 *  the screen as the home page scrolls rather than shrinking. */
export const HEADER_HEIGHT = 156;

type TScrollState = {
  useBackAnimation: boolean;
  setUseBackAnimation: (bool: boolean) => void;
  atTop: boolean;
  atBottom: boolean | null;
  setAtTop: (bool: boolean) => void;
  setAtBottom: (bool: boolean) => void;
  scrollBehavior: "smooth" | "auto" | "initial";
  setScrollBehaviour: (scrollBehav: "smooth" | "auto" | "initial") => void;
  scrollIntoView: (ref: React.MutableRefObject<any>) => void;
};

export const useScrollContext = create<TScrollState>()(
  devtools(
    (set) => ({
      useBackAnimation: false,
      atTop: true,
      atBottom: true,
      scrollBehavior: "smooth",
      setUseBackAnimation: (bool: boolean) => {
        set(() => ({
          useBackAnimation: bool,
        }));
      },
      setAtTop: (bool: boolean) => {
        set(() => ({
          atTop: bool,
        }));
      },
      setAtBottom: (bool: boolean) => {
        set(() => ({
          atBottom: bool,
        }));
      },
      setScrollBehaviour: (scrollBehav: "smooth" | "auto" | "initial") => {
        set(() => ({
          scrollBehavior: scrollBehav,
        }));
      },
      scrollIntoView: (containerRef: React.MutableRefObject<HTMLDivElement>) => {
        requestAnimationFrame(() => {
          if (!containerRef?.current?.getBoundingClientRect) {
            return;
          }

          const containerRect = containerRef.current.getBoundingClientRect();
          const windowHeight = window.innerHeight;

          const thresholdPercentage = 40;
          const threshold = (thresholdPercentage / 100) * windowHeight;
          const isNearBottom = containerRect.bottom + threshold >= windowHeight;

          if (isNearBottom) {
            containerRef.current.scrollIntoView({
              behavior: "auto",
              block: "start",
            });
          }
        });
      },
    }),
    {
      enabled: DEVTOOLS_ENABLED,
      name: "scrollState",
    },
  ),
);
